<template>
  <div id="footer" class="container">
    <div>

      <div class="row">

        <div class="col-6 col-md-4">
          <h4 class="text-white mt-0 mb-0 p-0"><a-number :value="this.ec" :round="true" :formatValue="format_ec" /> <small style="font-size: 16px; color: rgba(255, 255, 255, 0.5); display: block;">EC i omløp</small></h4>
        </div>

        <div class="col-6 col-md-4 text-right text-md-left">
          <ul>
            <li><router-link to="/regler">
              Regler
            </router-link></li>

            <li><router-link to="/staff">
              Staff
            </router-link></li>

            <li><router-link to="/highscore/ec">
              Topp rikeste
            </router-link></li>

            <!--
            <li><router-link to="/søknader/ny">
              Søk deg inn i personalet
            </router-link></li>

            <li><router-link to="/">
              Klag på en admin eller mod
            </router-link></li>

            <li><router-link to="/">
              Rapporter en bug
            </router-link></li>
            -->
          </ul>
        </div>

        <div class="col-6 col-md-3 offset-3 offset-md-1 text-center text-white">
          <router-link to="/">
            <img src="@/assets/images/logo_white.png" />
          </router-link>

          <p class="mt-1 mt-md-3 mb-0" style="color: rgba( 255, 255, 255, 0.3 );"><small>2020 &copy; Et produkt fra Bergen!</small></p>
        </div>

      </div>

      <div class="row mt-md-4">
        <div class="col-12 col-md-4">
          <a class="discord d-flex">
            <img src="@/assets/images/art_parrot.png" />
            <p>
              <strong>Spill med oss!</strong>
              <small>Minecraft IP: <strong class="d-inline">elytra.no</strong></small>
            </p>
          </a>
        </div>

        <div class="col-12 col-md-4">
          <a class="discord d-flex" href="https://discord.elytra.no/" target="_blank">
            <i class="fab fa-discord"></i>
            <p>
              <strong>Discord invite</strong>
              <small>Bli med oss på Discord da!</small>
            </p>
          </a>
        </div>

        <div class="col-12 col-md-4">
          <a class="discord d-flex" href="https://minecraft-mp.com/server/331246/vote/" target="_blank">
            <i class="fad fa-trophy"></i>
            <p>
              <strong>Stem på oss</strong>
              <small>Gi Elytra din stemme, få en premie!</small>
            </p>
          </a>
        </div>
      </div>

      <p class="text-center mt-5 mb-0" style="color: rgba( 255, 255, 255, 0.3 );">
        Minecraft: <strong class="mr-4">1.21.5</strong>
        Elytra: <strong>0.1.0</strong>
      </p>

      <div class="text-center mb-5 mt-3">
        <h4 class="text-white m-0 p-0" v-if="playersCount > 1">{{ playersCount }} <small style="font-size: 16px;">spillere pålogget</small></h4>
        <h4 class="text-white m-0 p-0" v-if="playersCount === 1">Èn <small style="font-size: 16px;">spiller nå!</small></h4>
        <h4 class="text-white m-0 p-0" v-if="!playersCount"><span style="width: 60px; display: inline-block;">{{ nadaWord }}</span> <small style="font-size: 16px; color: rgba(255, 255, 255, 0.5);">spillere på :(</small></h4>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 offset-md-3 text-center" style="color: rgba( 255, 255, 255, 0.1 );">
          <p>Elytra er ikke assosiert med Minecraft, Mojang Studios eller Microsoft på noen som helst måte.
          Elytra er ett privat spill-samfunn som spiller Minecraft. Minecraft er produsert
          og lansert av Mojang Studios.</p>
        </div>
      </div>

      <div class="pig"></div>

    </div>
  </div>
</template>

<script>
import Statistics from '@/api/statistics'

import { mapGetters } from 'vuex'
import Filters from '@/mixins/filters'

export default {
  name: 'Footer',
  mixins: [Filters],

  data: function() {
    return {
      nadaWord: 'Ingen',
      nadaWords: [
        'Null',
        'Zero',
        'нуль',
        'Nula',
        'Nul',
        'Nolla',
        'Cero',
        'Nulla',
        'Nialas',
        'Nulis',
        'Sero',
        'զրո',
        'sıfır',
        'Sifar',
        'Kore',
        'Efu',
        'Lefela',
        'Eber',
        'Sufuri',
        'Odo',
        'Ziro'
      ],
      ec: 0,
      ec_in: 0,
      ec_out: 0,
      achievements: {
        earned: 0
      },
      playing: {
        mineraft: 0,
        blackjack: {
          in: 0,
          out: 0
        },
        roulette: {
          in: 0,
          out: 0
        },
        lotto: 0,
        rr: 0
      },
      doing: {
        work: 0,
        crime: {
          in: 0,
          out: 0
        },
        write: 0
      },
      teleporting: {
        random: 0,
        home: 0
      },
      killing: {
        mobs: {
          in: 0,
          out: 0
        }
      },
      buying: {
        items: 0,
        property: {
          total: 0,
          own: 0,
          rent: 0
        }
      },
      selling: {
        items: 0
      },
      transferring: {
        p2p: 0
      }
    }
  },

  mounted() {
    this.nadaChanger()
    Statistics.ec(data => {
      this.ec = data.ec
      this.ec_in = data.in
      this.ec_out = data.out
      this.achievements = data.achievements
      this.playing = data.playing
      this.doing = data.doing
      this.teleporting = data.teleporting
      this.killing = data.killing
      this.buying = data.buying
      this.selling = data.selling
      this.transferring = data.transferring
    })
  },

  computed: {
    ...mapGetters( {
      playersCount: 'players/getOnlinePlayerServersCount'
    } )
  },

  methods: {
    nadaChanger() {
      if (this.playersCount) return
      const index = this.nadaWords.indexOf(this.nadaWord)
      const word = this.nadaWords[index + 1] || this.nadaWords[0]
      if (!word) return
      this.nadaWord = word
      setTimeout(() => this.nadaChanger(), 200)
    }
  }
}
</script>
